let hiddenTimeout;
let currentSlide = 0;

function syncDots(activeDot) {
    document.querySelectorAll('#ad-dots .out-dot').forEach((dot) => {
        dot.classList.toggle('out-dot--active', dot.dataset.dot === String(activeDot));
    });
}

function syncSlides() {
    document.querySelectorAll('#advertisement .ad-slide').forEach((slide) => {
        const index = Number(slide.dataset.slide);
        slide.classList.toggle('ad-slide--active', index === currentSlide);
        slide.classList.toggle('ad-slide--left', index < currentSlide);
    });
}

/*
 * Impression tracking: the first time a slide is actually on screen it is
 * registered on the model (sendBeacon to /ad-view) and as a GA event.
 */
const trackedAdViews = new Set();

function trackVisibleSlide() {
    // The ad is often prepared while the tab is hidden (the blur timer that
    // shows it behind the scenes); only count an impression when the page
    // is actually on screen. The visibility handlers below re-run this the
    // moment the visitor returns.
    if (document.visibilityState !== 'visible') return;

    const slide = document.querySelector(`#advertisement .ad-slide[data-slide="${currentSlide}"]`);
    if (!slide) return;

    const adId = slide.dataset.adId;
    if (!adId || trackedAdViews.has(adId)) return;
    trackedAdViews.add(adId);

    if (slide.dataset.viewUrl) {
        if (navigator.sendBeacon) {
            navigator.sendBeacon(slide.dataset.viewUrl);
        } else {
            fetch(slide.dataset.viewUrl, { method: 'POST', keepalive: true });
        }
    }

    if (typeof gtag === 'function') {
        gtag('event', 'social_ad_view', {
            social_ad_id: adId,
            slide_index: currentSlide,
        });
    }
}

function showAdvertisement() {
    const advertisement = document.getElementById('advertisement');
    if (!advertisement) return;

    advertisement.style.display = 'block';
    syncSlides();
    syncDots(currentSlide);
    trackVisibleSlide();

    // The dots stay hidden until the ad appears for the first time;
    // after that they remain available to switch between page and ads.
    const dots = document.getElementById('ad-dots');
    if (dots) dots.style.display = 'flex';
    document.body.classList.add('has-ad-dots');
}

function hideAdvertisement() {
    const advertisement = document.getElementById('advertisement');
    if (!advertisement) return;

    advertisement.style.display = 'none';
    syncDots('page');
}

function adShowSlide(index) {
    currentSlide = index;
    showAdvertisement();
}

function adShowPage() {
    hideAdvertisement();
}

function startHiddenTimer() {
    hiddenTimeout = setTimeout(() => {
        showAdvertisement();
    }, 200);
}

function stopHiddenTimer() {
    clearTimeout(hiddenTimeout);
}

document.addEventListener('visibilitychange', () => {
    if (window.isAndroid) {
        showAdvertisement();
    }

    if (document.visibilityState === 'hidden') {
        startHiddenTimer();
    } else if (document.visibilityState === 'visible') {
        stopHiddenTimer();

        // The visitor came back with the ad already open: this is the moment
        // the impression actually happens.
        if (advertisementVisible()) {
            trackVisibleSlide();
        }
    }
});

window.addEventListener('blur', () => {
    //if (!buttonPressed) return;
    startHiddenTimer();
});

window.addEventListener('focus', () => {
    stopHiddenTimer();
});
// (optioneel) voor nog betere support:
window.addEventListener('pagehide', () => {
    //if (!buttonPressed) return;
    startHiddenTimer();
});

window.addEventListener('pageshow', () => {
    stopHiddenTimer();

    if (advertisementVisible()) {
        trackVisibleSlide();
    }
});

/*
 * Drag navigation. The slides track the pointer 1:1 while dragging and
 * snap to the next/previous slide (or back) on release. The sequence is
 * [page, ad 0, ad 1, ...]: dragging the first ad to the right returns to
 * the plain page, swiping left on the page opens the first ad.
 */
let dragStartX = 0;
let dragStartY = 0;
let dragDeltaX = 0;
let dragging = false;
let suppressClick = false;

function slideElements() {
    return [...document.querySelectorAll('#advertisement .ad-slide')];
}

function slideCount() {
    return slideElements().length;
}

function advertisementVisible() {
    const advertisement = document.getElementById('advertisement');

    return advertisement && advertisement.style.display !== 'none';
}

function dotsVisible() {
    const dots = document.getElementById('ad-dots');

    return dots && dots.style.display !== 'none';
}

function slideWidth() {
    return document.getElementById('ad-slides')?.clientWidth || window.innerWidth;
}

function setDragTransforms(deltaX) {
    const width = slideWidth();

    slideElements().forEach((slide) => {
        const index = Number(slide.dataset.slide);
        const base = index === currentSlide ? 0 : (index < currentSlide ? -width : width);
        // Only the active slide and its direct neighbours track the pointer;
        // the rest stays parked off-screen, otherwise they stack up visibly.
        const follows = Math.abs(index - currentSlide) <= 1;
        slide.style.transform = `translateX(${base + (follows ? deltaX : 0)}px)`;
    });
}

function clearDragState() {
    dragging = false;
    slideElements().forEach((slide) => slide.classList.remove('ad-slide--dragging'));
}

function clearInlineTransforms() {
    slideElements().forEach((slide) => {
        slide.style.transform = '';
    });
}

// Native image/link dragging swallows the pointerup on desktop, so it is
// disabled whenever the ad slideshow is on the page.
document.addEventListener('dragstart', (event) => {
    if (document.getElementById('advertisement')) {
        event.preventDefault();
    }
});

document.addEventListener('pointerdown', (event) => {
    if (!event.isPrimary) return;

    dragStartX = event.clientX;
    dragStartY = event.clientY;
    dragDeltaX = 0;
    suppressClick = false;

    if (advertisementVisible()) {
        dragging = true;
        slideElements().forEach((slide) => slide.classList.add('ad-slide--dragging'));
    }
}, { passive: true });

document.addEventListener('pointermove', (event) => {
    if (!dragging || !event.isPrimary) return;

    dragDeltaX = event.clientX - dragStartX;

    // Rubber band when dragging past the last slide
    const atLastSlide = currentSlide === slideCount() - 1 && dragDeltaX < 0;
    setDragTransforms(atLastSlide ? dragDeltaX * 0.3 : dragDeltaX);

    if (Math.abs(dragDeltaX) > 10) {
        suppressClick = true;
    }
}, { passive: true });

document.addEventListener('pointerup', (event) => {
    if (!event.isPrimary || !document.getElementById('advertisement')) return;

    if (dragging) {
        const threshold = slideWidth() * 0.2;
        let targetSlide = currentSlide;
        let backToPage = false;

        if (dragDeltaX < -threshold && currentSlide < slideCount() - 1) {
            targetSlide = currentSlide + 1;
        } else if (dragDeltaX > threshold) {
            if (currentSlide === 0) {
                backToPage = true;
            } else {
                targetSlide = currentSlide - 1;
            }
        }

        clearDragState();

        if (backToPage) {
            clearInlineTransforms();
            adShowPage();

            return;
        }

        // Update the class-based positions first, then release the inline
        // transforms so the slides animate from the dragged position
        // straight to their new spot without snapping back.
        currentSlide = targetSlide;
        syncSlides();
        syncDots(currentSlide);
        clearInlineTransforms();
        trackVisibleSlide();

        return;
    }

    // Overlay hidden: a left swipe on the plain page opens the first ad
    const deltaX = event.clientX - dragStartX;
    const deltaY = event.clientY - dragStartY;

    if (deltaX < -50 && Math.abs(deltaX) > Math.abs(deltaY) && dotsVisible()) {
        suppressClick = true;
        adShowSlide(0);
    }
}, { passive: true });

document.addEventListener('pointercancel', () => {
    if (!dragging) return;

    clearDragState();
    clearInlineTransforms();
});

// A drag that starts on the CTA link would still fire its click on
// release; swallow that one click so dragging never navigates.
document.addEventListener('click', (event) => {
    if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
    }
}, true);

// A forced ad (?socialAd=...) renders the overlay open server-side, so the
// initial impression is tracked here instead of via showAdvertisement().
if (advertisementVisible()) {
    trackVisibleSlide();
}

window.hideAdvertisement = hideAdvertisement;
window.adShowSlide = adShowSlide;
window.adShowPage = adShowPage;
